import Hero from "components/MainPage/Hero";
import Features from "components/MainPage/Features";
import PopularProducts from "components/MainPage/PopularProducts";
import WhyUs from "components/MainPage/WhyUs";
import { Helmet } from "react-helmet";
import TechnologyPartners from "components/MainPage/TechnologyPartners";

function MainPage() {
	return (
		<>
			<Helmet title="Lark-strech"/>
			<div className="main-page">
				<Hero/>
				<Features/>
				<PopularProducts/>
				<TechnologyPartners/>
				<WhyUs/>
			</div>
		</>
	);
}

export default MainPage;